import styled from 'styled-components';

export const InputLayout = styled.div`
    align-items: center;

    &.inline {
        display: flex;
        justify-content: space-between;
    }

    &.without-label {
        flex: 0 0 auto;
    }

    owc-typography.label {
        color: var(--one-color-interaction-default-intensity-medium);

        &.block {
            padding-bottom: 8px;
        }
    }

    /* OWC-OVERRIDE: owc-input has a fixed ~250px default width on its host and no width prop
       in v7.6.0; the doubled class raises specificity enough to beat owc's own :host rule so
       the field fills its form row. */
    owc-input.owc-input {
        width: 100%;
    }

    owc-input.owc-input.inline {
        width: 40%;
    }

    owc-input.space-for-error {
        margin-bottom: 20px !important;
    }

    owc-input.floating-assistive-text {
        margin-bottom: 0 !important;
    }
`;

export const AssistiveTextLayout = styled.div`
    display: flex;
    flex-direction: column;
`;
